window.PlummeI18n.register('no', {
  'inv.pay.undoPayment': 'Angre betaling',
  'inv.pay.undoRefund': 'Angre tilbakebetaling',
  'inv.pay.undoPaymentTitle': 'Angre registrert betaling?',
  'inv.pay.undoRefundTitle': 'Angre registrert tilbakebetaling?',
  'inv.pay.undoPaymentBody': 'Betalingen reverseres og fakturaen åpnes igjen med tilsvarende restbeløp. Den opprinnelige føringen beholdes i historikken.',
  'inv.pay.undoRefundBody': 'Tilbakebetalingen reverseres og kundens tilgodebeløp åpnes igjen. Den opprinnelige føringen beholdes i historikken.',
  'inv.toast.paymentReversed': 'Betalingen er reversert',
  'inv.toast.refundReversed': 'Tilbakebetalingen er reversert',
  'inv.err.paymentReverseFailed': 'Kunne ikke reversere betalingen.',
  'inv.err.refundReverseFailed': 'Kunne ikke reversere tilbakebetalingen.',
});
